import { NavigateOptions, useNavigate } from 'react-router-dom'
import useRuntime from './useRuntime'

const useLinkTo = () => {
  const { channel } = useRuntime()
  const navigate = useNavigate()

  const getLink = (href: string = '') => {
    if (href.indexOf('/') !== 0) {
      return href
    }

    const basePath = channel ? `/${channel}/` : ''
    const link = (basePath + href).replace('//', '/')

    return link
  }

  const linkTo = (href: string = '', options?: NavigateOptions) => {
    navigate(getLink(href), options)
  }

  return {
    getLink,
    linkTo
  }
}

export default useLinkTo
